<template>
  <transition>
    <div class="sa-f-up-attach">
      <div class="sa-f-up-att">
        <input
          type="file"
          ref="file"
          @change="onFileChange"
          @input-file="inputFile"
          class="sa-d-none"
          id="chatatt"
          name="chatatt"
          :data="{ uploadtype: 'profilepic' }"
          post-action="https://imgpre.litedev.com/upload"
        />
        <button
          type="submit"
          class="sa-btn sa-chat-btn sa-chat-attach"
          @click="selectFile"
        >
          <i class="icon-attachment"></i>
        </button>
      </div>
      <div class="sa-f-up-doc">
        <span class="sa-f-up-info" v-if="file"><img :src="file" alt="" /></span>
        <span class="sa-f-up-name sa-ellipsis" v-if="file">{{ fileName }}</span>
        <button
          ref="removeFile"
          type="submit"
          class="sa-btn sa-btn-primary sa-chat-cancel"
          @click="removeFile"
          v-if="file"
        >
          Cancel
        </button>
      </div>
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-attach-loader"
        v-if="loader"
      />
    </div>
  </transition>
</template>
<script>
import axios from "axios";
export default {
  watch: {
    triggerCancel: {
      immediate: true,
      deep: true,
      handler() {
        if (this.triggerCancel) {
          this.$refs.removeFile.click();
        }
      },
    },
  },
  data() {
    return {
      file: "",
      fileName: "",
      loader: false,
    };
  },
  props: ["triggerCancel"],
  methods: {
    selectFile() {
      this.$refs.file.click();
    },
    inputFile(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.response &&
        newFile.response.data &&
        newFile.response.data[0] &&
        newFile.response.data[0] &&
        newFile.response.data[0].url
      ) {
      }
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    async onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.loader = true;
      const formData = new FormData();
      formData.append("filename", files[0]);
      formData.append("data", { uploadtype: "profilepic" });
      let response = await axios.post(
        "https://imgpre.litedev.com/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data[0] &&
        response.data.data[0].url
      ) {
        this.$emit("file-upload-success", response.data.data[0]);
        this.loader = false;
      }
      this.fileName = files[0].name;
      this.createImage(files[0]);
      // this.$parent.setImg(files[0].type)
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.file = e.target.result;
        this.$emit("change", this.file);
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.file = "";
      this.fileName = "";
      this.$parent.msgText = "";
    },
  },
};
</script>
